/**
 * Centralized permission constants matching Common.Constants.Permissions.
 * CPNotes: Keep strings identical to the backend — names are case-sensitive
 */
export const Permissions = {
  users: {
    create: 'users.create',
    read: 'users.read',
    update: 'users.update',
    delete: 'users.delete',
    list: 'users.list',
    viewDetails: 'users.view_details',
  },
  system: {
    manageRoles: 'system.manage_roles',
    managePermissions: 'system.manage_permissions',
    viewLogs: 'system.view_logs',
    manageSettings: 'system.manage_settings',
  },
  data: {
    read: 'data.read',
    write: 'data.write',
    delete: 'data.delete',
    export: 'data.export',
    import: 'data.import',
  },
  reports: {
    view: 'reports.view',
    create: 'reports.create',
    export: 'reports.export',
  },
  ads: {
    manage: 'ads.manage',
  },
} as const;
